import React, { forwardRef } from "react"
import cx from "classnames"

import { kebabCase } from "lodash"
import Badge from "@kit/design/badge"
import { PaidFeatureBadge } from "app/navigation/utils/paid-feature-badge"

export const SourceTab = forwardRef(
  (
    {
      title,
      icon,
      active,
      onClick,
      isPaidFeature,
      needsReauthenticate,
      canNavigate
    },
    ref
  ) => {
    const isDisabled = needsReauthenticate && !canNavigate

    const className = cx(
      "flex items-center px-3 py-2 w-full text-left focus:outline-blue border border-transparent rounded hover:bg-gray-50",
      {
        "bg-gray-50": active,
        "opacity-50 cursor-not-allowed": isDisabled
      }
    )

    return (
      <button
        ref={ref}
        aria-expanded={active}
        className={className}
        onClick={onClick}
        disabled={isDisabled}
        title={
          isDisabled ? "Update required - reinstall from App Store" : undefined
        }
        data-testid={`${kebabCase(title)}-tab-picker`}
      >
        <div className="flex justify-center items-center w-8 h-8 mr-3 flex-shrink-0">
          {icon}
        </div>
        <span className="text-sm text-gray-800 font-semibold truncate">
          {title}
        </span>
        {needsReauthenticate && (
          <Badge className="ml-2 flex-shrink-0" color="orange">
            Update required
          </Badge>
        )}
        {isPaidFeature && !needsReauthenticate && (
          <PaidFeatureBadge className="ml-2 flex-shrink-0" />
        )}
      </button>
    )
  }
)
